import {
  CandidateBatchGroup,
  SearchCandidatesBatchesQuery
} from 'generated-graphql/graphql';

export const updateCandidateBatchGroupLocally = (
  prevData: SearchCandidatesBatchesQuery,
  candidateBatchIds: string[],
  candidateBatchGroup: Pick<CandidateBatchGroup, 'id' | 'name'>
): SearchCandidatesBatchesQuery => {
  return {
    ...prevData,
    searchCandidateBatches: {
      ...prevData.searchCandidateBatches,
      items:
        prevData.searchCandidateBatches?.items.map((item) =>
          item && candidateBatchIds.includes(item.id)
            ? {
                ...item,
                candidateBatchGroup: {
                  id: candidateBatchGroup.id,
                  name: candidateBatchGroup.name
                }
              }
            : item
        ) ?? []
    }
  };
};
